import { useEffect, useRef, useState } from 'react';
import decodeRelativeDates from '@afosto/utils-react/date/decodeRelativeDates';
import encodeRelativeDates from '@afosto/utils-react/date/encodeRelativeDates';
import getRelativeTodayQuery from '@afosto/utils-react/date/getRelativeTodayQuery';
import isDateTypeToday from './isDateTypeToday';

export default ({ operator, value, onChange }) => {
  const [type, setType] = useState('');
  const operatorRef = useRef(operator);
  const valueRef = useRef(value);

  useEffect(() => {
    operatorRef.current = operator;
    valueRef.current = value;
  });

  useEffect(() => {
    setType('');
  }, [operator]);

  useEffect(() => {
    const currentValue = valueRef.current;

    const decodeDateValues = async () => {
      try {
        const decodedValues = await decodeRelativeDates(currentValue);
        const formattedValues = decodedValues
          .filter(
            decodedValue =>
              !decodedValue?.query?.at?.day_of_week && !decodedValue?.query?.at?.day_of_month,
          )
          .map(decodedValue => decodedValue?.formatted)
          .filter(formattedValue => formattedValue);

        if (isDateTypeToday(operatorRef?.current, formattedValues)) {
          setType('today');
          return;
        }

        if (decodedValues?.length > 0) {
          const [firstValue] = decodedValues;

          if (firstValue?.query?.at?.hour === 'now') {
            setType('relativeNow');
          } else {
            setType('relative');
          }
        } else {
          setType('relative');
        }
      } catch (err) {
        setType('relative');
      }
    };

    if (operatorRef?.current && currentValue?.length > 0) {
      const [firstValue] = currentValue;

      if (firstValue && typeof firstValue === 'string' && firstValue?.startsWith('_')) {
        decodeDateValues().catch(() => {
          // Catch only.
        });
      } else {
        setType('date');
      }
    }
  }, []);

  const handleChangeType = async (ev, dateType) => {
    try {
      setType(dateType);

      if (onChange && typeof onChange === 'function') {
        if (dateType === 'today') {
          const options = getRelativeTodayQuery(operator);
          const relativeDates = await encodeRelativeDates(options);
          const filterValues = relativeDates
            .map(relativeDate => relativeDate?.filter)
            .filter(encodedValue => encodedValue);

          onChange({}, filterValues);
        }

        if (!dateType || dateType !== 'today') {
          onChange({}, []);
        }
      }
    } catch (err) {
      if (onChange && typeof onChange === 'function') {
        onChange({}, []);
      }
    }
  };

  return [type, handleChangeType];
};
